import { Component, OnInit, Inject } from '@angular/core';
import { RcContext } from 'app/modules/remote-control-ng/context/rcContext';

@Component({
  selector: 'app-remote-control-device-rotation',
  templateUrl: './remote-control-device-rotation.component.html',
  styleUrls: ['./remote-control-device-rotation.component.scss']
})

export class RemoteControlDeviceRotationComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }
  public clientSideRotate = () => RcContext.instance.deviceScreenTransformService.clientSideRotate(false);
}
